import api from "@/api/apiConfig"
import {
  Post,
  Put,
  Delete
} from './base/baseAjax'
let getMenusList = (param) => {
  return Post({
    url: api.setMenus.getMenusList,
    bodyParam: param
  })
}
let addMenus = (param) => {
  return Post({
    url: api.setMenus.addMenus,
    bodyParam: param
  })
}
let editMenus = (param) => {
  return Put({
    url: api.setMenus.editMenus,
    bodyParam: param
  })
}
let deleteMenus = (param) => {
  return Post({
    url: api.setMenus.deleteMenus,
    bodyParam: param
  })
}

export default {
  getMenusList,
  addMenus,
  editMenus,
  deleteMenus
}



// WEBPACK FOOTER //
// ./src/services/setMenus.js